module.exports = __webpack_public_path__ + "img/ywcq_3.f7990809.jpg";